<mat-tab-group>
  @for (tab of field.fieldGroup; track tab) {
    <mat-tab [label]="tab.props?.label ?? ''">
      <!-- TODO(bambang): add optional props disabled state for tabs based on validity of the previous tab. check https://formly.dev/docs/examples/advanced/tabs/-->
      <formly-field [field]="tab"></formly-field>
    </mat-tab>
  }
</mat-tab-group>
